﻿window.cBuilderEmailWidgetRetourTop = function(option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetretourtop'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>Retour top</div>").appendTo($DivBt)
        $DivBt.attr("title", "Ajouter un lien permettant de revenir au début de votre email")
        return $DivBt
    }

    this.mCreateElement = function () {
        option.element = $("<tr class='widget dxwidgetretourtop'>")
        $("<!-- DEBUT LIEN RETOUR TOP -->").appendTo(option.element)
        var $Td = $("<td valign='top' style='word-break:break-word;with:100%;' width='100%' class='bodywidget tdwidget widgetheightauto'></td>").appendTo(option.element)
        var jsonDuplik = JSON.parse(JSON.stringify(option.dxBuilderEmailPage.mJsonCssGuideProperty("lienretourtop")))
        for (var prop in jsonDuplik) jsonDuplik[prop] = ""
        $Td.attr("jsoncssdatawidget", JSON.stringify(jsonDuplik))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'/>").appendTo($Tr)
        $("<a href='#'>Retour au début</a>").appendTo($Td)

        $("<!-- FIN LIEN RETOUR TOP -->").appendTo(option.element)
    }

    this.nom = "Retour top"
    this.icone = "fas fa-file-arrow-up"

    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()

        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Texte du lien:</td>").appendTo(contentElement)
        var oldTxt = option.parent.mGetContenuWidget().find("a").text()
        contentElement.closest(".dx-item-content").css("overflow", "visible")
        $("<div/>").appendTo(contentElement).dxCtrlTxtEmoji({
            bddCtrl: option.bddCtrl,
            pickerPosition: "bottom",
            value: oldTxt,
            placeholder: "Texte du lien de retour au début...",
            onValueChanged: function (value) {
                option.parent.mGetContenuWidget().find("a").text(value)
            },
            onLoad: function () {
            }
        }).dxCtrlTxtEmoji("instance")
    }

    this.mAddCtrlStyle = function (contentElement) {
        contentElement.empty()

        var jsonCssDataOriginalValue = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        var jsonCssData = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("lienretourtop")) {
            jsonCssData[prop] = ""
            if (typeof jsonCssDataOriginalValue[prop] != 'undefined') jsonCssData[prop] = jsonCssDataOriginalValue[prop]
        }
        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Style du texte:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleFont({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            value: jsonCssData,
            showAlign: false,
            allowDefaut: true,
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    if (value.value.length > 0) { jsonCssDataOriginalValue[value.prop] = value.value }
                    else { delete jsonCssDataOriginalValue[value.prop] }
                })
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })
    }

    this.mRemoveStyle = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("lienretourtop")) {
            delete jsonCssData[prop]
        }
        option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssData))
        option.onValueChanged()
    }

    this.mUpdateCss = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("lienretourtop")) {
            if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                option.parent.mGetBodyWidget().css(prop, jsonCssData[prop])
            } else {
                option.parent.mGetBodyWidget().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("lienretourtop", prop))
            }
        }
    }

}